import { observable, action, configure, runInAction, flow } from 'mobx';

import ClassesApi from '@api/classes.api';

interface IClassesStore {
  classes: { name: string, teacherName: string, minStudentsNumber: string | number, maxStudentsNumber: string | number, schoolBus: boolean, institution: string }[],
  currentClass: { name: string, teacherName: string, minStudentsNumber: string | number, maxStudentsNumber: string | number, schoolBus: boolean, institution: string }
  isLoading: boolean;
  errors: any;
}

configure({ enforceActions: 'observed' });

class ClassesStore implements IClassesStore {
  @observable classes: any[] = [];

  @observable currentClass: any = null;

  @observable isLoading = false;

  @observable errors: any = null;

  @action.bound
  handleChange ({ target: { name, value } }: { target: HTMLInputElement }) {
    this.currentClass[name] = value;
  }

  getClassesList = flow(function* getClassesList (id: string) {
    this.isLoading = true;

    try {
      const list = yield ClassesApi.fetch(id);

      this.classes = list;
      this.isLoading = false;
    } catch (error) {
      this.errors = error;
      this.isLoading = false;
    }
  });
}

export default new ClassesStore();
